import { useState } from "react";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { useApi } from "../../lib/useApi";
import { api, formatApiError } from "../../lib/api";
import { Loader, ErrorState, PageHeader } from "../../components/common/States";
import { fmtDate } from "../../lib/labels";
import { AUDIT_CATEGORY } from "../../lib/platform";

const detailText = (d) => {
  if (!d || !Object.keys(d).length) return "";
  if (d.reason) return `Motif : ${d.reason}`;
  if (d.note) return `Note : ${d.note}`;
  return JSON.stringify(d).slice(0, 160);
};

export default function AdminLogs() {
  const [q, setQ] = useState("");
  const [applied, setApplied] = useState({ q: "", category: "", page: 1 });
  const { data, loading, error, reload } = useApi(`/admin/audit-logs?q=${encodeURIComponent(applied.q)}&category=${applied.category}&page=${applied.page}`);

  return (
    <div>
      <PageHeader title="Journal d'audit" description="Opérations sensibles : permissions, suspensions, suppressions, factures, modération et paramètres." />
      <div className="mb-6 flex flex-col gap-2 sm:flex-row">
        <form className="flex-1" onSubmit={(e) => { e.preventDefault(); setApplied({ ...applied, q, page: 1 }); }}>
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filtrer par action, email ou identifiant…" data-testid="admin-logs-search" />
        </form>
        <select className="field-select sm:w-60" value={applied.category} onChange={(e) => setApplied({ ...applied, category: e.target.value, page: 1 })} data-testid="admin-logs-category-filter">
          <option value="">Toutes les opérations</option>{Object.entries(AUDIT_CATEGORY).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
      </div>
      {loading && <Loader />}
      {error && <ErrorState message={error} onRetry={reload} />}
      {data && (
        <>
          <div className="card-surface overflow-x-auto">
            <table className="w-full min-w-[820px] text-sm">
              <thead className="border-b bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
                <tr><th className="px-4 py-3">Date</th><th className="px-4 py-3">Acteur</th><th className="px-4 py-3">Action</th><th className="px-4 py-3">Cible</th><th className="px-4 py-3">Détails</th></tr>
              </thead>
              <tbody className="divide-y">
                {data.items.map((l) => (
                  <tr key={l.id} data-testid="admin-log-row">
                    <td className="whitespace-nowrap px-4 py-2.5 text-slate-500">{fmtDate(l.created_at)}</td>
                    <td className="px-4 py-2.5">{l.actor_name || l.actor_email}<p className="text-xs text-slate-400">{l.actor_email}</p></td>
                    <td className="px-4 py-2.5 font-mono text-xs">{l.action}</td>
                    <td className="px-4 py-2.5 font-mono text-xs text-slate-500">{l.target_type}:{String(l.target_id).slice(0, 8)}</td>
                    <td className="max-w-xs px-4 py-2.5 text-xs text-slate-600">{detailText(l.details)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {!data.items.length && <p className="p-4 text-sm text-slate-500">Aucune opération pour ce filtre.</p>}
          </div>
          <div className="mt-4 flex items-center justify-end gap-2 text-sm text-slate-500">
            <span data-testid="admin-logs-total">{data.total} opération(s)</span>
            <Button variant="outline" size="sm" disabled={data.page <= 1} onClick={() => setApplied({ ...applied, page: applied.page - 1 })} data-testid="admin-logs-prev">Précédent</Button>
            <span>{data.page} / {data.pages}</span>
            <Button variant="outline" size="sm" disabled={data.page >= data.pages} onClick={() => setApplied({ ...applied, page: applied.page + 1 })} data-testid="admin-logs-next">Suivant</Button>
          </div>
        </>
      )}
    </div>
  );
}
